module.exports = __webpack_public_path__ + "static/img/18.27231bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/18.png
// module id = Evm2
// module chunks = 0